import className from "classnames/bind";
import { Button } from "@components";
import ShareButton from "../ShareButton/ShareButton";

import styles from "./DigitalExhibitQuiz.module.scss";
const cx = className.bind(styles);

type QuizControlsProps = {
  variant: "question" | "results";
  onBack?: () => void;
  onNext?: () => void;
  onRetake?: () => void;
  onShare?: () => Promise<boolean>;
  canAdvance?: boolean;
  backLabel?: string;
  nextLabel?: string;
  retakeLabel?: string;
  shareLabel?: string;
  copiedLabel?: string;
  showShare?: boolean;
};

export default function QuizControls({
  variant,
  onBack,
  onNext,
  onRetake,
  onShare,
  canAdvance = false,
  backLabel = "Back",
  nextLabel = "Next",
  retakeLabel = "Retake",
  shareLabel,
  copiedLabel,
  showShare = true,
}: QuizControlsProps) {
  return (
    <div
      className={cx("dx-quiz__controls", { "dx-quiz__controls--results": variant === "results" })}
      data-quiz-stagger
    >
      {variant === "question" ? (
        <>
          <Button label={backLabel} onClick={onBack} type="button" noIcon />
          <Button label={nextLabel} onClick={onNext} type="button" disabled={!canAdvance} />
        </>
      ) : (
        <>
          <Button label={retakeLabel} onClick={onRetake} type="button" noIcon />
          {showShare && (
            <ShareButton moduleSlug="quiz" defaultLabel={shareLabel} copiedLabel={copiedLabel} onShare={onShare} />
          )}
        </>
      )}
    </div>
  );
}
